import { FC, InputHTMLAttributes, Ref } from 'react'
import { cn } from '../../../utils/cn'

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  hasError?: boolean
  ref?: Ref<HTMLInputElement>
}
export const Input: FC<InputProps> = ({
  className,
  hasError,
  ref,
  type = 'text',
  ...rest
}) => {
  const inputClassName = cn(
    'm-0 block h-full w-full grow bg-none p-0 text-slate-950 placeholder:font-light placeholder:text-slate-600 focus:outline-none focus:ring-0',
    {
      '!text-red-600': hasError
    },
    className
  )
  return (
    <input
      ref={ref}
      type={type}
      className={inputClassName}
      {...rest}
      aria-invalid={hasError}
    />
  )
}
